export default function biddingButton() {
  const fixedBiddingBtn = document.getElementById('fixed-bidding-button');
  if (fixedBiddingBtn) {
    fixedBiddingBtn.addEventListener('click', () => {
      const dialogBtn = document.getElementById('bidding-dialog-button');
      if (dialogBtn) {
        dialogBtn.click();
      }
    });
  }
}
